import React, { Component } from 'react';
import { FilterContainer } from 'js/academia_components/navs/filter/filter_container';
import { FilterItem } from 'js/academia_components/navs/filter/filter_item';
import ReaderCards from './readers_cards.wjs';
import { FindReadersReport } from './FindReadersReport';
import commaizeInt from 'js/utils/commaize';
import { $ } from 'global';

export class ReadersTabContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: 'all',
      counts: {},
    };
  }

  componentDidMount() {
    // Use the correct API endpoint that we know works from the server logs
    const countsUrl = $r.all_counts_api_v0_readers_path({
      subdomain_param: 'api',
      user_id: Aedu.User.current.id,
    });

    $.getJSON(countsUrl)
      .done((res) =>
        this.setState({
          counts: {
            highly_engaged: res.highly_engaged_count || 0,
            in_field: res.in_field_count || 0,
            in_network: res.in_network_count || 0,
            all: res.total_count || 0,
          },
        }),
      )
      .fail(() => {
        // Fallback if API doesn't work
        this.setState({
          counts: {
            highly_engaged: 0,
            in_field: 0,
            in_network: 0,
            all: 0,
          },
        });
      });
  }

  handleFilterChange = (filter) => () => {
    this.setState({ filter });
  };

  render() {
    return (
      <>
        {/* Renders nothing unless the viewer has a Find Readers batch inside the cooldown. */}
        <FindReadersReport />
        <FilterContainer
          className="MainHeaderContainer"
          content={<ReaderCards filter={this.state.filter} />}
        >
          {this.renderFilterItem('all', 'All')}
          {this.renderFilterItem('highly_engaged', 'Highly Engaged')}
          {this.renderFilterItem('in_network', 'In Your Network')}
          {this.renderFilterItem('in_field', 'In Your Field')}
        </FilterContainer>
      </>
    );
  }

  renderFilterItem(filter, name) {
    return (
      <FilterItem
        onClick={this.handleFilterChange(filter)}
        active={this.state.filter === filter}
        rightText={commaizeInt(this.state.counts[filter] || 0)}
        disabled={this.state.counts[filter] === 0}
      >
        {name}
      </FilterItem>
    );
  }
}
